import script from "./BlockInputNationalId.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockInputNationalId.vue?vue&type=script&setup=true&lang=js"

import "./BlockInputNationalId.vue?vue&type=style&index=0&id=77e19e9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e19e9a"]])

export default __exports__